import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import TodayIcon from '@material-ui/icons/Today';
import classNames from 'classnames';
import Currency from '../../../../Currency';

import useStyles from '../makeStyles';

const SelectOption = ({
  item, selectedPackage, handlePackageChange,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div
      className={classNames(classes.selectContainer, {
        [classes.active]: selectedPackage.value === item.value,
      })}
      onClick={() => handlePackageChange(item)}
      role="presentation"
    >
      <div className={classes.left}><TodayIcon className={classes.todayIcon} /></div>
      <div className={classes.right}>
        <div className={classes.label}>
          {t('travel.packageLabelYear', item)}
        </div>
        <div className={classes.amount}>
          <Currency
            value={item.amount}
            withSymbol
          />
        </div>
      </div>
    </div>
  );
};

SelectOption.propTypes = {
  item: PropTypes.shape({
    value: PropTypes.number,
    amount: PropTypes.number,
  }).isRequired,
  selectedPackage: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  }).isRequired,
  handlePackageChange: PropTypes.func.isRequired,
};

export default SelectOption;
